import React from 'react';
import Section from './Section';
import { Link } from 'react-router-dom';

const NotaOficial = () => {
  const notas = [
    {
      key: 'nota-repudio-organizacao-xxxv-cba',
      badge: 'Nota Oficial',
      title:
        'AEAGO manifesta seu repúdio à condução unilateral da organização do XXXV Congresso Brasileiro de Agronomia – CBA',
      date: '24 de julho de 2026',
      image: '/imagem/NOTA OFICIAL.png',
      aspect: '3919 / 2354',
      bg: '#00204F',
      action: { type: 'link', to: '/noticias/nota-repudio-organizacao-xxxv-cba', label: 'Leia a nota completa' },
    },
    {
      key: 'comunicado-cba-posicionamento-institucional',
      badge: 'Comunicado Oficial',
      title:
        'AEAGO reforça posicionamento institucional sobre a organização do XXXV Congresso Brasileiro de Agronomia – CBA',
      date: '8 de setembro de 2026',
      image: '/imagem/comunicado-cba.png',
      aspect: '1672 / 941',
      bg: '#01295A',
      action: {
        type: 'download',
        href: '/documentos/Oficio_442026_assinado-cba.pdf',
        label: 'Baixar comunicado (PDF)',
      },
    },
  ];

  return (
    <Section id="nota-oficial" bgClass="bg-gray-50" title="Nota Oficial">
      <p className="max-w-3xl mx-auto text-center mb-8 text-gray-700">
        Fique por dentro das comunicações e posicionamentos institucionais da AEAGO. O assunto do XXXV CBA segue repercutindo — acompanhe abaixo os posicionamentos mais recentes.
      </p>
      <div className="max-w-5xl mx-auto space-y-6">
        {notas.map((nota) => (
          <div
            key={nota.key}
            className="bg-white rounded-xl overflow-hidden flex flex-col md:flex-row shadow-2xl"
          >
            <div
              className="w-full md:w-1/2 flex-shrink-0 aspect-[var(--nota-aspect)] md:aspect-auto flex items-center justify-center"
              style={{ backgroundColor: nota.bg, '--nota-aspect': nota.aspect }}
            >
              <img
                src={process.env.PUBLIC_URL + encodeURI(nota.image)}
                alt={nota.badge}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-5 md:p-6 flex flex-col justify-center">
              <span className="inline-block bg-navy text-white text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full mb-3 w-fit">
                {nota.badge}
              </span>
              <h3 className="text-base md:text-lg font-bold mb-2 leading-snug text-navy">
                {nota.title}
              </h3>
              <p className="text-sm text-gray-500 mb-4">{nota.date}</p>
              {nota.action.type === 'download' ? (
                <a
                  href={process.env.PUBLIC_URL + encodeURI(nota.action.href)}
                  download
                  className="inline-block bg-navy text-white py-2 px-6 rounded-full border border-gold hover:bg-secondary transition w-fit"
                >
                  {nota.action.label}
                </a>
              ) : (
                <Link
                  to={nota.action.to}
                  className="inline-block bg-navy text-white py-2 px-6 rounded-full border border-gold hover:bg-secondary transition w-fit"
                >
                  {nota.action.label}
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default NotaOficial;
